import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VIEW_OFFERS_FEATURE } from '../reducers';
import * as fromOffer from '@view-offers/store/reducers';

const getOffersState =
  createFeatureSelector<fromOffer.ViewOffersState>(VIEW_OFFERS_FEATURE);

export const getComparisonsState = createSelector(
  getOffersState,
  (state) => state?.comparisons
);

export const getComparisons = createSelector(
  getComparisonsState,
  (state) => state?.data
);
